
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'


import './style.css'
import Experience from './Experience.jsx'
import Panel from './Panel'
import App from './App'



const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
    <App />
)